import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'gen-sample-viewer',
  templateUrl: './sample-viewer.component.html',
  styleUrls: ['./sample-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SampleViewerComponent implements OnInit {
  @Input() sampletype: string;
  @Input() primaryid: string;
  @Input() samples: Array<any>;
  @Input() samplesConfig: Array<any>;
  @Input() showaddbutton: boolean;
  @Input() overrides: any = { };
  @Input() allowedit: boolean;
  @Input() disabledForced: boolean;
  @Input() markAsPrimaryEnabled: boolean;
  @Input() proceedToAnaliseStarted: boolean;
  @Input() editMode: boolean;
  @Input() callback?: () => void;
  @Output() updatedOrder: EventEmitter<{ specimen: Array<any>, primaryTumor: string}> = new EventEmitter();

  constructor() {
  }

  ngOnInit() {
  }

  emitUpdate(data) {
    this.updatedOrder.emit(data);
  }
}
